import React, { useCallback, useState } from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../components/button';
import { IdName } from '../common/types';
import { EmployeeSkillsSidebar } from '../managerForEmployee/EmployeeSkillsSidebar';
import { SkillsMatrixConnected } from '../skillsMatrix/SkillsMatrixConnected';
import { ManageSkillsSidebar } from './ManageSkillsSidebar';
import { EngagementContainer } from '../../../manager/EngagementContainer';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import { useFlairBreadcrumbHook } from '../../../../../hooks/useFlairBreadcrumbHook';

export const SkillsManagerPage: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { t } = useTranslation();

  const tNavigation = useNamespacedTranslation(
    'navigation.menuItems.teamDevelopment',
  );

  useFlairBreadcrumbHook([
    { label: tNavigation('title') },
    { label: tNavigation('subMenuItems.skills.title') },
  ]);

  const [manageSkillsVisible, setManageSkillsVisible] =
    useState<boolean>(false);

  const [selectedEmployee, setSelectedEmployee] = useState<IdName | null>(null);

  const handleManageSkillsClick = useCallback(() => {
    setManageSkillsVisible(true);
  }, [setManageSkillsVisible]);

  return (
    <EngagementContainer
      title={t('performanceReview.subMenuItems.skills.title')}>
      <Card>
        <Card.Header className="d-flex justify-content-between">
          <div className="fw-bold">{t('skills.title')}</div>
          <Button
            size="sm"
            variant="outline-primary"
            label={t('skills.manager.title')}
            onClick={handleManageSkillsClick}
          />
        </Card.Header>
        <Card.Body className="px-0 pb-0">
          <SkillsMatrixConnected onEmployeeClick={setSelectedEmployee} />
        </Card.Body>
      </Card>
      <ManageSkillsSidebar
        visible={manageSkillsVisible}
        onClose={() => setManageSkillsVisible(false)}
      />
      <EmployeeSkillsSidebar
        visible={selectedEmployee !== null}
        employeeId={selectedEmployee?.id ?? ''}
        employeeName={selectedEmployee?.name ?? ''}
        onClose={() => setSelectedEmployee(null)}
      />
    </EngagementContainer>
  );
};
